module.exports = __webpack_public_path__ + "static/media/s-home_formats_podcast.84808b6d.jpg";